import dayjs from 'dayjs'
import { t } from 'i18next'
import { get, lowerCase } from 'lodash'
import { useEffect, useRef, useState } from 'react'

function Header({ training, showInfo, dateFormat }) {
    const getDate = () => {

        let currentFormat = getFormatUser() ?? 'DD/MM/YYYY HH:mm'

        return get(training, 'training.creation_date')
            ? dayjs(get(training, 'training.creation_date')).format(currentFormat)
            : ' - '
    }

    const getFormatUser = () => {
        if (!dateFormat) return null

        let charMapper = {
            "d": 'DD',
            "m": "MM",
            "y": "YYYY"
        }

        let joinChar = '-'

        return String(dateFormat).split('/').map(char => charMapper[lowerCase(char)]).join(joinChar).concat(' HH:mm')

    }

    const getTrainingType = () => {
        let type = training?.training?.training_type?.display_name
        let auto = training?.training?.training_type_automatic?.display_name
        if (type) {
            return type
        } else if (auto) {
            return auto
        } else {
            return null
        }
    }
    const getTrackName = () => {
        let type = training?.training?.track_name?.display_name
        let auto = training?.training?.track_name_automatic?.display_name
        if (type) {
            return type
        } else if (auto) {
            return auto
        } else {
            return null
        }
    }

    const getComment = () => {
        return get(training, 'training.comment', null)
    }

    const getArioneoComment = () => {
        return get(training, 'training.flash_comment', null)
    }

    const getAutomaticComment = () => {
        return get(training, 'training.comment_automatic', null)
    }

    const getInfo = () => {
        let info = []
        if (getTrainingType()) {
            info = [getTrainingType()]
        }
        if (getTrackName()) {
            info = [...info, getTrackName()]
        }
        if (get(training, 'training.rider.display_name', null)) {
            info = [...info, get(training, 'training.rider.display_name', null)]

        }
        return info
    }

    const CommentBox = ({ url, maxHeight }) => {
        const [isTruncated, setIsTruncated] = useState(false);
        const contentRef = useRef(null);

        useEffect(() => {
            if (contentRef.current.scrollHeight > maxHeight) {
                setIsTruncated(true);
            }
        }, [maxHeight]);

        var contentBoxMaxHeight = maxHeight + 12;

        return (
            <div className="content-box " style={{ maxHeight: `${contentBoxMaxHeight}px` }}>
                <p ref={contentRef} className={"content " + (isTruncated ? "truncated" : "")} style={{ maxHeight: `${maxHeight}px` }} >
                    {getComment() ? (
                        <p className='font-semibold gap-1 text-xs'>
                            <span style={{ whiteSpace: 'nowrap' }}>{t('editTrainingForm:comment:label')} :</span>
                            <span className='font-normal text-xs'>{getComment()}</span>
                        </p>
                    ) : getArioneoComment() ? (
                        <p className='font-semibold gap-1 text-xs'>
                            <span style={{ whiteSpace: 'nowrap' }}>{t('qualification:commentArioneo')} : </span>
                            <span className='font-normal text-xs'>{getArioneoComment()}</span>
                        </p>
                    ) : getAutomaticComment() && (
                        <p className='font-semibold gap-1 text-xs'>
                            <span style={{ whiteSpace: 'nowrap' }}>{'Arion Intelligence (Beta)'} * : </span>
                            <span className='font-normal text-xs'>{getAutomaticComment()}</span>
                        </p>
                    )}
                </p>
                {
                    isTruncated && (
                        <p className='w-full text-center'><a href={url} target="_blank" rel="noopener noreferrer" className="see-more-link text-xs ">{t('seeMore')}
                        </a></p>
                    )
                }


            </div >
        );
    };

    return (
        <div className='mt-1 md:mt-1'>
            <div className='flex flex-row justify-between items-center relative'>
                <div className='bg-gradient-to-r bg-gradient p-1 md:p-1 ps-1 pe-1 md:ps-2 md:pe-2 w-3/4 rounded-e-full flex justify-between items-center'>
                    <p className='text-lg md:text-xl text-white font-semibold'>{get(training, 'training.horse_trainer.horse.name', '-')}</p>
                    <p className='text-sm md:text-l text-white font-medium'>{getDate()}</p>
                </div>

                <img className='grayscale pe-5 h-full w-16 md:w-16' src="/logo.png" alt="" />
            </div>
            
            {showInfo && <div className='py-1 ps-5 pe-5'>
                <p className='text-xs '>{getInfo().join(' - ')}</p>
                {
                    (getComment() || getArioneoComment() || getAutomaticComment()) && <CommentBox url={get(training, "training.public_url", null)} maxHeight={120} />
                }
            </div>
            }

        </div>
    )
}

export default Header
